<template>
  <div class="card">
    <div class="card-body">
      <h4 class="card-title mb-4">{{ $t('pages.review.index.latest_reviews') }}
        <span class="text-muted">({{ $t('pages.review.index.last_days', {days: 90}) }})</span>
      </h4>

      <ul class="list-group">
        <simplebar style="max-height: 350px">
          <div v-if="reviews.length > 0 && !loading">
            <li class="list-group-item border-0" v-for="review in reviews" :key="review.id">
              <div class="media">
                <div class="avatar-xs me-3">
                      <span class="avatar-title rounded-circle bg-light">
                        <img
                            :src="review.img"
                            alt
                            height="18"
                        />
                      </span>
                </div>
                <div class="media-body">
                  <h5 class="font-size-14">{{ review.title }}</h5>
                  <p class="text-muted">
                    {{ review.review }}
                  </p>

                  <div class="float-end">
                    <p class="text-muted mb-0">
                    <span style="margin-right: 6px;">
                      <i class="mdi mdi-calendar-range me-1"></i>
                      {{ review.date | date}}
                    </span>
                      <i class="mdi mdi-account me-1"></i> {{ review.name }}
                    </p>
                  </div>
                  <p class="text-muted mb-0">
                    <star :star="review.rating"/>
                  </p>
                </div>
              </div>
            </li>
          </div>
          <no-content v-else :loading="loading"/>
        </simplebar>
      </ul>
    </div>
  </div>
</template>

<script>
import simplebar from "simplebar-vue";
import ProductService from "../../../Services/Api/ProductService";
import Star from "./Star";

export default {
  name: "LatestReviews",
  components: {simplebar, Star},
  data() {
    return {
      reviews: [],
      loading: false
    }
  },
  methods: {
    async getLastReviews() {
      this.loading = true
      const {data: reviews} = await ProductService.latestReviews()
      this.reviews = reviews.data
      this.loading = false
    }
  },
  created() {
    this.getLastReviews()
  }
}
</script>

<style scoped>

</style>